import React from "react";
import Download from "../../../assets/icon/Download-Icon3.svg";

const DownloadCSVButton = ({
  monthsdata,
  valuedata1,
  valuedata2,
  valuedata3,
  valuedata4,
  heading1,
  filenamedata,
}) => {
  const handleDownload = () => {
    // Data
    const value1 = valuedata1;
    const value2 = valuedata2 ? valuedata2 : [];
    const value3 = valuedata3 ? valuedata3 : [];
    const value4 = valuedata4 ? valuedata4 : [];
    const months = monthsdata;
    const arr = [];

    // Preparing the data
    for (let i = 0; i < value1?.length; i++) {
      const row = {
        Months: months[i],
        value1: value1[i],
      };

      // Only add value2 if it's available
      if (value2 && value2[i] !== undefined) {
        row.value2 = Number(value2[i]).toFixed(2);
      }

      if (value3 && value3[i] !== undefined) {
        row.value3 = Number(value3[i]).toFixed(2);
      }

      if (value4 && value4[i] !== undefined) {
        row.value4 = Number(value4[i]).toFixed(2);
      }

      arr.push(row);
    }

    // Headers for CSV file
    const headers = heading1;

    // Convert the data into CSV format
    const csvData = arr.reduce((acc, row) => {
      const { Months, value1, value2, value3, value4 } = row;
      const rowData = [`"${Months}"`, `"${value1}"`];

      if (value2 !== undefined) rowData.push(`"${value2}"`);
      if (value3 !== undefined) rowData.push(`"${value3}"`);
      if (value4 !== undefined) rowData.push(`"${value4}"`);

      acc.push(rowData.join(","));

      return acc;
    }, []);

    // Combine headers and data into the CSV string
    const csvContent = [headers.join(","), ...csvData].join("\n");

    // Triggering the download
    const downloadFile = (data, fileName, fileType) => {
      const blob = new Blob([data], { type: fileType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };

    downloadFile(csvContent, filenamedata, "text/csv");

  };

  return (
    <div>
      <img className="dow_hover" onClick={handleDownload} src={Download} alt="Download CSV" />
      {/* <button>Download CSV File</button> */}
    </div>
  );
};

export default DownloadCSVButton;
